import React from 'react';
import { useTranslation } from 'next-i18next';
import Button from '@components/atoms/button/button';
import Dialog from '@components/atoms/dialog/dialog';
import styles from './confirm-dialog.module.scss';

interface ConfirmDialogProps {
  setOpen: (isOpen: boolean) => void;
  open: boolean;
  title: string;
  content: string;
  onCancel: () => void;
  onConfirm: () => void;
  cancelBtnTxt?: string;
  confirmBtnTxt?: string;
  focusTrapActive?: boolean;
  parentSelector?: () => HTMLElement;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  setOpen,
  open,
  title,
  content,
  onCancel,
  onConfirm,
  cancelBtnTxt,
  confirmBtnTxt,
  focusTrapActive = false,
  parentSelector,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      customClass={styles.dialog}
      focusTrapActive={focusTrapActive}
      isOpen={open}
      hasCloseIcon
      hasCloseTxt
      closeDialog={setOpen}
      fullScreenOnMobile={false}
      parentSelector={parentSelector}
      styles={{
        content: { padding: '2rem 1.5rem 1.5rem', maxWidth: '25.5rem' },
      }}
    >
      {(modalDialogTitleId) => (
        <div>
          <h2
            className={styles.title}
            id={modalDialogTitleId}
          >
            {title}
          </h2>
          <div className={styles.content}>{content}</div>
          <div className={styles.buttonwrap}>
            <Button
              className={styles.button}
              variant="secondary"
              size="large"
              onClick={onCancel}
              data-cy="my-sizes-confirm-cancel-button"
            >
              {cancelBtnTxt || t('PLP.MYSIZES_DIALOG.CONFIRM_CANCEL')}
            </Button>

            <Button
              className={styles.button}
              onClick={onConfirm}
              variant="primary"
              size="large"
              data-cy="my-sizes-confirm-delete-button"
            >
              {confirmBtnTxt || t('PLP.MYSIZES_DIALOG.CONFIRM_BUTTON')}
            </Button>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default ConfirmDialog;
